
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M31.68 9.556s-.313-2.221-1.272-3.199c-1.217-1.284-2.581-1.29-3.206-1.365-4.478-.326-11.195-.326-11.195-.326h-.014s-6.717 0-11.195.326c-.626.074-1.989.08-3.207 1.364C.632 7.334.32 9.554.32 9.554S0 12.162 0 14.77v2.445c0 2.608.32 5.216.32 5.216s.312 2.221 1.271 3.198c1.218 1.284 2.817 1.244 3.529 1.378 2.56.248 10.88.324 10.88.324s6.724-.01 11.202-.336c.625-.076 1.989-.081 3.206-1.366.959-.978 1.272-3.198 1.272-3.198s.32-2.607.32-5.216V14.77c0-2.607-.32-5.216-.32-5.216zM12.696 20.18l-.001-9.055 8.646 4.543-8.645 4.512z","fill":"currentColor"}})])
          )
        }
      }
    